import { Element } from "../models/elementModel";
import { Row } from "../models/rowModel";
import { Section } from "../models/sectionModel";
import { AppState } from "../reducers/rootReducer";

export const getSession = (state: AppState) => state.session;
export const getViewRemark = (state: AppState) => state.session.viewRemark;
export const getProject = (state: AppState) => state.projectList;
export const getSessionSelectedType = (state: AppState) => state.session.selectedType;
export const getSessionSelectedForm = (state: AppState) => state.session.selectedFormId;
export const getSessionSelectedRow = (state: AppState) => state.session.selectedRowId;
export const getSessionSelectedElement = (state: AppState) => state.session.selectedElementId;
export const getForms = (state: AppState) => state.formList;
export const getElementTemplates = (state: AppState) => state.elementTemplateList;
export const getElementTemplateByType = (type:String) => (state: AppState) => { return state.elementTemplateList.filter((elementTemplate) => elementTemplate.type === type )};
export const getAllRowsAndSectionsAndElementsByFormId = (id: String) => (state: AppState) => {
    let elementList: Element[] = [];
    let sectionList: Section[] = [];
    let rowList: Row[] = state.rowList.filter((row) => { return row.formId === id });
    
    for (let index = 0; index < rowList.length; index++) {
        const sectionListByRowId: Section[] = state.sectionList.filter((section) => { return section.rowId === rowList[index].id });
        sectionList = sectionList.concat(sectionListByRowId);
        for (let j = 0; j < sectionListByRowId.length; j++) {
            const elementListBySectionId: Element[] = state.elementList.present.filter((element) => { return element.sectionId === sectionListByRowId[index].id });
            elementList = elementList.concat(elementListBySectionId);
        }
    }
    return ({
        rowList: rowList,
        sectionList: sectionList,
        elementList: elementList
    })
}